import * as net from 'util/Net';

/** Benchling credits are transferred in fixed increments. */
export const BOLTZ_CREDIT_INCREMENT = 1000;

/** Maximum Benchling credits that can be transferred in a single deposit. */
export const BOLTZ_MAX_CREDITS_PER_TRANSFER = 5000;

export interface BoltzApiKeys {
  workspaceId: string;
  liveApiKey: string;
  testApiKey: string;
}

/**
 * Transfer Benchling credits to the Boltz API. The backend verifies the tenant has enough credits
 * (returning a 402 otherwise), increases the Boltz spending limit, and debits the credits.
 */
export async function transferBoltzCredits(creditAmount: number): Promise<void> {
  await net.postJSONPromise({
    url: '/1/api/model-hub/boltz-api/credit-transfer',
    data: {creditAmount},
  });
}

/** Provision live and test Boltz API keys. The keys are only returned once and cannot be retrieved again. */
export async function provisionBoltzApiKeys(): Promise<BoltzApiKeys> {
  return (await net.postJSONPromise({
    url: '/1/api/model-hub/boltz-api/api-keys',
    data: {},
  })) as BoltzApiKeys;
}
